import React from "react"
import UMRLogo from "../assets/icons/umr/uni-marburg-logo-weiss.svg"

const Umr: React.FC<{ className: string }> = ({ className }) => (
  <a href="https://www.uni-marburg.de/" class="">
    <span class={className}>
      <UMRLogo class="h-16" />
    </span>
  </a>
)

export default Umr
